// extracted by mini-css-extract-plugin
module.exports = {"button":"e336fd7528--button--GVLSF"};